import { render, staticRenderFns } from "./HlStats.vue?vue&type=template&id=c01896f6"
import script from "./HlStats.vue?vue&type=script&lang=js"
export * from "./HlStats.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports